import React, { useState, useEffect } from 'react';
import './CustomerReviewSection.css';

const reviews = [
    {
        id: 1,
        stars: 5,
        text: "Thermomix TM7 ile mutfakta harikalar yaratmak çok kolay! Özellikle yoğun iş temposunda bana inanılmaz zaman kazandırıyor. Kesinlikle her evin ihtiyacı.",
        author: "Selin Yılmaz",
        title: "Thermomix Kullanıcısı"
    },
    {
        id: 2,
        stars: 5,
        text: "Eşimle birlikte kullanıyoruz ve bayılıyoruz. Rehberli pişirme özelliği sayesinde hiç denemediğimiz tarifleri bile cesaretle yapabiliyoruz. Sonuç her zaman mükemmel.",
        author: "Ahmet Kandoğan",
        title: "Thermomix Kullanıcısı"
    },
    {
        id: 3,
        stars: 5,
        text: "Bebeğim için en sağlıklı mamaları kendim hazırlamak istiyordum, Thermomix tam da aradığım yardımcı oldu. Katkısız, doğal ve pratik!",
        author: "Merve Demir",
        title: "Thermomix Kullanıcısı"
    },
    {
        id: 4,
        stars: 5,
        text: "Yemek yapmayı seven biri olarak, Thermomix mutfağımın baş tacı oldu. Sous-vide pişirme tekniğiyle etler lokum gibi oluyor. Teknolojisine hayranım.",
        author: "Hakan Çelik",
        title: "Thermomix Kullanıcısı"
    },
    {
        id: 5,
        stars: 5,
        text: "Sadece yemek değil, limonata, dondurma, hamur işleri... Yapabildiklerinin sınırı yok. Mutfaktaki en büyük yardımcım.",
        author: "Esra Koç",
        title: "Thermomix Kullanıcısı"
    }
];

const CustomerReviewSection: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const itemsVisible = isMobile ? 1 : 2;
    const maxIndex = Math.max(0, reviews.length - itemsVisible);

    // Ensure currentIndex is valid after resize
    useEffect(() => {
        if (currentIndex > maxIndex) {
            setCurrentIndex(maxIndex);
        }
    }, [maxIndex, currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
    };

    return (
        <section className="customer-review-section">
            <div className="customer-review-container">
                <button className="nav-button prev" onClick={prevSlide} aria-label="Önceki Yorum">
                    &#10094;
                </button>

                <div className="customer-review-slider">
                    <div
                        className="customer-review-track"
                        style={{
                            transform: `translateX(-${currentIndex * (100 / itemsVisible)}%)`
                        }}
                    >
                        {reviews.map((review) => (
                            <div key={review.id} className="customer-review-card-wrapper">
                                <div className="customer-review-card">
                                    <div className="customer-review-stars">
                                        {'★'.repeat(review.stars)}
                                    </div>
                                    <p className="customer-review-text">
                                        "{review.text}"
                                    </p>
                                    <div className="customer-review-author">
                                        <span className="author-name">{review.author}</span>
                                        <span className="author-title">{review.title}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button className="nav-button next" onClick={nextSlide} aria-label="Sonraki Yorum">
                    &#10095;
                </button>
            </div>
        </section>
    );
};

export default CustomerReviewSection;
